import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Firebase configuration từ Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyDmXta-Rj3FIcYqfG2PYtzp_npCk73Ymm8",
  authDomain: "aiprice-b95ff.firebaseapp.com",
  databaseURL:
    "https://aiprice-b95ff-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "aiprice-b95ff",
  storageBucket: "aiprice-b95ff.firebasestorage.app",
  messagingSenderId: "940908317180",
  appId: "1:940908317180:web:be3e6d0ec30e39b6604a79",
  measurementId: "G-2GVNH2QJGF",
};

// Khởi tạo Firebase App
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log("Firebase app initialized successfully");
} catch (error) {
  if (!/already exists/.test(error.message)) {
    console.error("Firebase initialization error", error.stack);
  }
}

// Khởi tạo Analytics với error handling
let analytics = null;
const initializeAnalytics = async () => {
  try {
    if (typeof window !== "undefined") {
      const supported = await isSupported();
      if (supported) {
        analytics = getAnalytics(app);
        console.log("Firebase Analytics initialized successfully");
      } else {
        console.warn("Firebase Analytics is not supported in this environment");
      }
    }
  } catch (error) {
    console.warn("Failed to initialize Firebase Analytics:", error);
    // Analytics không hoạt động không ảnh hưởng đến app
  }
};

// Gọi initialization
initializeAnalytics();

// Lấy instance của database
const db = getDatabase(app);

// Khởi tạo Auth
const auth = getAuth(app);

export { db, app, analytics, firebaseConfig, auth };
